import { render, staticRenderFns } from "./SalesStatementDetailView.vue?vue&type=template&id=72403b14&"
import script from "./SalesStatementDetailView.vue?vue&type=script&lang=js&"
export * from "./SalesStatementDetailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports